import { BaseModel } from '../../_base/crud';

export class Userfile extends BaseModel {
  id: number;
  name: string;
  date_created: Date;
  afile: string;
  user: number;
}
